<template>
  <div class="product-detail">
    <!-- 头部区域 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">商品详情</div>
      </div>
    </div>

    <div class="content-scroll">
      <div class="banner">
        <img :src="coverImage" alt="商品主图" />
        <!-- <div class="badge">国家补贴 85折</div> -->
        <!-- <div class="price-sticker">
        <div class="price-now">到手价 ¥{{ formatPrice(finalPrice) }}</div>
        <div class="price-origin" v-if="originalPrice && originalPrice !== finalPrice">日常价 ¥{{ formatPrice(originalPrice) }}</div>
      </div> -->
      </div>

      <div class="summary">
        <div class="title"><span
            style="font-size: 14px; color: #42b983;background-color: #42b98320;padding: 2px 4px;border-radius: 4px;">旗舰店</span>{{
              product?.skuName || '商品详情' }}</div>
        <div class="meta">
          <span>到手价 </span>
          <strong class="theme">¥{{ formatPrice(finalPrice) }}</strong>
          <span class="split">|</span>
          <span>佣金({{ formatPercent(commissionShare) }}) </span>
          <strong class="theme">¥{{ formatPrice(commission) }}</strong>
        </div>
      </div>

      <div class="shop-card">
        <div class="shop-info">
          <div class="shop-logo">{{ shopInfo?.shopName?.slice(0, 2) }}</div>
          <div class="shop-text" style="flex: 1;">
            <div class="shop-name">{{ shopInfo.shopName || '店铺' }}</div>
            <div class="shop-stars">
              <span v-if="shopInfo.shopLevel">评分 {{ shopInfo.shopLevel }}</span>
              <span v-if="shopInfo.logisticsLvyueScore">物流 {{ shopInfo.logisticsLvyueScore }}</span>
              <span v-if="shopInfo.afterServiceScore">售后 {{ shopInfo.afterServiceScore }}</span>
              <span>商品评价{{ product?.comments / 10000 }}万+</span>
              <span>好评率{{ product?.goodCommentsShare }}%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <div style="font-size: 14px;">
            <span>优惠攻略</span>
            <span @click="handleInvalidReport" style="margin-left: 10px; cursor: pointer; color: #42b983;font-size: 14px;
              border: 1px solid #42b983;padding: 2px 4px;border-radius: 4px;padding: 2px 4px;">失效上报</span>
          </div>
          <div style="display: flex;align-items: center;gap: 10px;font-size: 14px;">
            <span style="background: #42b983;color: #fff;padding: 2px 4px;border-radius: 4px;"
              @click="handleCopyAll">复制全部</span>
            <span style="background: #42b983;color: #fff;padding: 2px 4px;border-radius: 4px;"
              @click="handleCopyOrderLink">复制下单链接</span>
          </div>
        </div>
        <div class="coupon-box" ref="couponBox">
          <div v-if="product?.guideText">
            <div v-if="isRichText(product.guideText)">
              <div class="guide-text" style="white-space: pre-wrap;" v-html="product.guideText"></div>
            </div>
            <div v-else class="guide-text" style="white-space: pre-wrap;">{{ product?.guideText }}</div>
          </div>
          <div v-else>
            <div class="line">{{ product?.skuName }}</div>
            <div class="line">💰京东价￥{{ product?.priceInfo?.lowestPrice }}</div>
            <div class="line">🔥 9.5折 | 💰到手价 ￥{{ product?.priceInfo?.lowestPrice }}</div>

            <div class="line theme" style="align-items: normal;" v-for="dict in product?.couponInfo?.couponList"
              :key="dict.link">
              <span v-if="dict.isBest == 1" class="check-icon" style="white-space: nowrap;">🎉 优惠券减 {{ dict.discount }}
                ：</span>
              <span v-if="dict.isBest == 1" class="discount-text" style="word-break: break-all;">{{ dict.link }}</span>
            </div>
          </div>
          <div class="code" ref="orderLink">🛒 下单：{{ promotionLink || '生成中...' }}</div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">推广素材</div>
        <div class="gallery">
          <div v-for="(img, idx) in gallery" :key="idx" class="gallery-item" @click="toggleSelect(idx)">
            <img :src="img.url" alt="素材" />
            <label class="check">
              <input type="checkbox" :checked="isSelected(idx)" @change.prevent="toggleSelect(idx)" />
              <span class="box" :class="{ checked: isSelected(idx) }"></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="floating-actions">
      <button class="fab" @click="openPoster">生成海报</button>
      <button class="fab" @click="handleCopyAll">分享赚 ¥{{ formatPrice(commission) }}</button>
    </div>

    <PosterModal :visible="showPoster" :product="product || {}" :selectedImage="selectedImage" @close="closePoster" />
  </div>
</template>

<script>
import { createPromotionLink, reportPromotionContentInvalidBySpuid } from '@/utils/jdApi'
import { copyRichTextWithMessage } from '@/utils/clipboard'

export default {
  name: 'ProductDetail',
  components: {
    PosterModal: () => import('@/components/PosterModal.vue')
  },
  data() {
    return {
      product: null,
      fallbackCover: '',
      selectedIndexes: [],
      showPoster: false,
      promotionLink: null, // 存储转链后的推广链接
      promotionParams: null // 存储推广位参数
    }
  },
  computed: {
    coverImage() {
      return this.product?.imageInfo?.imageList[0]?.url || this.fallbackCover
    },
    gallery() {
      const list = this.product?.imageInfo?.imageList
      return list || []
    },
    selectedImage() {
      // 返回当前已选择的图片列表的第一张
      if (this.selectedIndexes.length > 0) {
        const firstSelectedIndex = this.selectedIndexes[0]
        const gallery = this.gallery
        if (gallery && gallery[firstSelectedIndex]) {
          return gallery[firstSelectedIndex].url
        }
      }
      // 如果没有选择图片，返回默认的第一张图片
      return this.coverImage
    },
    finalPrice() {
      return this.product?.priceInfo?.lowestPrice || '--'
    },
    originalPrice() {
      return this.product?.wlprice || 0
    },
    commission() {
      return this.product?.commissionInfo?.commission || 0
    },
    shopInfo() {
      return this.product?.shopInfo || {}
    },
    commissionShare() {
      return this.product?.commissionInfo?.commissionShare || 0
    }
  },
  async mounted() {
    const loaded = await this.loadProductFromSession()
    if (!loaded) {
      this.$router.replace('/promotion')
    }
  },
  watch: {
    '$route.query.id': {
      immediate: false,
      handler() {
        this.loadProductFromSession()
      }
    }
  },
  methods: {
    async loadProductFromSession() {
      try {
        const stored = sessionStorage.getItem('productDetail')
        if (stored) {
          const data = JSON.parse(stored)
          this.product = data
          // 提取推广位参数
          this.promotionParams = data.promotionParams
          // 生成推广链接
          await this.loadPromotionLink()
          return true
        }
      } catch (e) {
        console.warn('读取商品详情失败', e)
      }
      return false
    },
    // 判断是否为富文本内容
    isRichText(content) {
      // 简单的判断：如果内容包含HTML标签，则认为是富文本
      return /<[^>]*>/.test(content);
    },
    handleInvalidReport() {
      this.$confirm('确认该条信息已经失效、并上报！', '提示', {
        confirmButtonText: '确定',
        confirmButtonClass: 'confirm-dialog-button',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reportPromotionContentInvalidBySpuid(
          this.product.skuName || this.product.spuid, // 优先使用 skuName，如果没有则使用 spuid
          this.promotionParams.positionId,
          '商品详情页上报失效'
        ).then(response => {
          if (response && response.success) {
            this.$message({
              type: 'success',
              message: '上报成功!'
            })
          } else {
            this.$message.error('上报失败')
          }
        }).catch(() => {
          this.$message.error('上报失败')
        })
      }).catch(() => {
        // 用户取消
      })

    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.showToast('已复制到剪贴板')
      } catch (e) {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.showToast('已复制到剪贴板')
      }
    },
    handleCopyAll() {
      const box = this.$refs.couponBox
      if (!box) return
      // 获取内容，可能是 HTML 或纯文本
      const content = box.innerHTML || box.innerText || ''
      // 使用统一的工具函数复制，自动处理换行格式
      copyRichTextWithMessage(content, this, '已复制到剪贴板', '复制失败')
    },
    async handleCopyOrderLink() {
      try {
        // 如果还没有推广链接，先生成一个
        if (!this.promotionLink) {
          this.promotionLink = await this.generatePromotionLink()
        }
        if (this.promotionLink) {
          this.copyToClipboard(this.promotionLink)
        } else {
          // 如果转链失败，使用原有的硬编码链接
          const el = this.$refs.orderLink
          if (!el) return
          const match = String(el.innerText).match(/https?:\/\/\S+/)
          const link = match ? match[0] : el.innerText
          this.copyToClipboard(link)
        }
      } catch (error) {
        console.error('生成推广链接失败:', error)
        // 回退到原有逻辑
        const el = this.$refs.orderLink
        if (!el) return
        const match = String(el.innerText).match(/https?:\/\/\S+/)
        const link = match ? match[0] : el.innerText
        this.copyToClipboard(link)
      }
    },
    showToast(message) {
      const el = document.createElement('div')
      el.textContent = message
      Object.assign(el.style, {
        position: 'fixed',
        left: '50%',
        bottom: '80px',
        transform: 'translateX(-50%)',
        background: 'rgba(0,0,0,0.75)',
        color: '#fff',
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '12px',
        zIndex: '2000',
        transition: 'opacity .2s',
        opacity: '0'
      })
      document.body.appendChild(el)
      requestAnimationFrame(() => { el.style.opacity = '1' })
      setTimeout(() => {
        el.style.opacity = '0'
        setTimeout(() => el.remove(), 200)
      }, 1500)
    },
    openPoster() {
      this.showPoster = true
    },
    closePoster() {
      this.showPoster = false
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },
    formatPrice(value) {
      if (!value) return '0.00'
      return Number(value).toFixed(2)
    },
    formatPercent(percent) {
      if (!percent) return '0%'
      return Number(percent).toFixed(1) + '%'
    },
    toggleSelect(idx) {
      const i = this.selectedIndexes.indexOf(idx)
      if (i === -1) {
        this.selectedIndexes.push(idx)
      } else {
        this.selectedIndexes.splice(i, 1)
      }
    },
    isSelected(idx) {
      return this.selectedIndexes.indexOf(idx) !== -1
    },
    async loadPromotionLink() {
      this.promotionLink = await this.generatePromotionLink()
    },
    async generatePromotionLink() {
      if (!this.product || !this.product.itemId) {
        console.warn('商品信息不完整，无法生成推广链接')
        return null
      }

      if (!this.promotionParams) {
        console.warn('推广位参数不完整，无法生成推广链接')
        return null
      }

      try {
        const response = await createPromotionLink({
          materialId: this.product.itemId,
          positionId: this.promotionParams.positionId
        })

        // 解析新的返回格式：{ code, link, goodsInfo }
        // 保持向后兼容：优先使用 link 字段，如果没有则使用 data 字段
        if (response && response.code === 200) {
          let linkData = null
          if (response.link) {
            // 新格式：link 字段包含转链结果
            linkData = response.link.data || response.link
          } else if (response.data) {
            // 旧格式：直接使用 data 字段
            linkData = response.data
          }
          
          if (linkData) {
            // 优先使用shortURL，如果没有则使用clickURL
            const link = linkData.shortURL || linkData.clickURL
            return link
          } else {
            console.warn('转链接口返回格式异常:', response)
            return '无法生成链接请联系团长'
          }
        } else {
          console.warn('转链接口返回格式异常:', response)
          return '无法生成链接请联系团长'
        }
      } catch (error) {
        console.error('调用推广链接接口失败:', error)
        return '无法生成链接请联系团长'
      }
    }
  }
}
</script>

<style scoped>
.theme {
  color: #42b983;
}

.theme-bg {
  background: #42b983;
  color: #fff;
}

.product-detail {
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
}

/* 尺寸变量（可按需调整） */
:root {
  --pd-header-h: 56px;
  /* 预估头部高度（含内边距和圆角） */
  --pd-footer-h: 72px;
  /* 底部按钮区域高度（含内边距） */
}

.content-scroll {
  height: calc(100vh - 124px);
  overflow: auto;
  padding-bottom: 12px;
  /* 内容与底部留白 */
}

.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #42b983, #369870);
  padding: 4px;
  border-radius: 12px;
  margin-bottom: 10px;
  color: white;
}

/* 使滚动高度准确：测得头部真实高度作为变量使用 */
.header {
  min-height: var(--pd-header-h);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.banner {
  position: relative;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: white;
}

.banner img {
  width: 100%;
  height: auto;
  display: block;
}

.badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #2c3e50;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  opacity: 0.9;
}

.price-sticker {
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 8px 12px;
  line-height: 1.2;
}

.price-now {
  color: #e74c3c;
  font-weight: 700;
}

.price-origin {
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}

.summary {
  background: white;
  border-radius: 0 0 12px 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.summary .title {
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
}

.meta {
  color: #666;
  font-size: 14px;
}

.split {
  margin: 0 10px;
  color: #ddd;
}

.cta-group {
  margin-top: 12px;
  display: flex;
  gap: 10px;
}

.btn {
  border: none;
  padding: 10px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.btn.outline {
  background: #fff;
  color: #42b983;
  border: 1px solid #42b983;
}

.btn.small {
  padding: 6px 10px;
  font-size: 12px;
}

.shop-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shop-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.shop-logo {
  width: 36px;
  height: 36px;
  border-radius: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #42b983;
  color: #fff;
  font-weight: 700;
}

.shop-name {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.shop-stars {
  font-size: 12px;
  color: #888;
  display: flex;
  column-gap: 10px;
  flex-wrap: wrap;
}

.section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  color: #2c3e50;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
}

.coupon-box {
  background: #f9f9f9;
  border: 1px dashed #42b983;
  padding: 12px;
  border-radius: 8px;
  color: #000;
}

.coupon-box .line {
  font-size: 14px;
  margin: 4px 0;
}

.coupon-box .code {
  font-family: monospace;
  color: #2c3e50;
  background: #fff;
  border: 1px solid #eee;
  padding: 6px;
  border-radius: 6px;
  word-break: break-all;
}

.coupon-box .guide-text {
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.coupon-box .guide-text /deep/ p {
  margin: 4px 0;
  display: block;
}

.coupon-box .guide-text /deep/ br {
  display: block;
  line-height: 1.6;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.gallery-item {
  position: relative;
}

.gallery img {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #eee;
  display: block;
}

.check {
  position: absolute;
  top: 6px;
  right: 6px;
}

.check input {
  display: none;
}

.check .box {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #fff;
  background: rgba(0, 0, 0, 0.25);
  display: inline-block;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.check .box.checked {
  background: #42b983;
  border-color: #42b983;
  box-shadow: 0 0 0 1px rgba(66, 185, 131, 0.4);
}

.floating-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, rgba(245, 245, 245, 0) 0%, #f5f5f5 60%);
  display: flex;
  gap: 10px;
}

.fab {
  width: 100%;
  background: #42b983;
  color: #fff;
  border: none;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.fab:hover {
  background: #369870;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

/* 响应式设计 */
@media (max-width: 480px) {
  .product-detail {
    padding: 10px;
  }

  .header {
    padding: 4px;
  }

  .summary,
  .shop-card,
  .section {
    padding: 10px;
  }

  .gallery {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
</style>
